<sgt-select
  [options]="options"
  [settings]="settings"
  [variante]="variante"
  [(ngModel)]="selectedId"
  (ngModelChange)="onSelectionChange()"
  (isFirstOpened)="firstOpened()">
</sgt-select>
